import React, { useState } from "react";
import LogoConstructora from "../UI/svg/logo-constructora-baw.svg";
import LogoProyecto from "../UI/svg/logo-proyecto.svg";
import LogoArakatu from "../UI/svg/LOGO-ARAKATU.svg";
import adorno from "../UI/adorno-welcome.png";

function BienvenidoContainer({ loaded, loading, cachedImages, welcome, proyecto, loadedImages, constructora}) {
  const [total, setTotal] = useState(24);
  return (
    <div className={`loading-div ${!loading ? " fadeIn " : "fadeOut2"}`}>
      <div>
        <img className={`logo-constructora ${ !loading ? " fadeIn" : "fadeOut" }`} alt="" id="Logo_Proyecto" src={LogoConstructora} />
        {/*<img className={`logo-proyecto ${ loaded && cachedImages && !welcome ? " fadeIn" : "fadeOut" } `} alt="" id="Logo_Proyecto" src={LogoArakatu} />*/}
        {/*<img className={`logo-proyectos ${ loaded && cachedImages && !welcome ? " fadeIn" : "fadeOut" } `} alt="" id="Logo_Proyecto" src={LogoProyecto} />*/}
        <svg className={ !loaded || !cachedImages ? "loader-circle fadeIn" : "loader-circle fadeOut"} viewBox="0 0 150 150" xmlns="http://www.w3.org/2000/svg">
          <circle className={`internal-circle ${proyecto.Nombre ? "animated" : ""}`} cx="75" cy="75" r="70" ></circle>
        </svg>
      </div>
      <span className={loaded && cachedImages && !loading ? "fadeIn" : "fadeOut"} >
        {!loading ? "Cargando" : "Bienvenidos"}
      </span>
      <span className={ !loaded || !cachedImages ? "blink_me fadeIn" : "blink_me fadeOut2" } id="rotate">
        <span>Descargando datos...</span>
        <span>Descargando datos...</span>
        <span>Descargando datos...</span>
        <span>Procesando...</span>
      </span>
    </div>
  );
}

export default BienvenidoContainer;
